import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import React from "react";
import { object, bool, string } from "prop-types";
import Styled from "styled-components";
import moment from "moment-timezone"; // UI

import { H6 } from "@uprise/headings";
import { Tiny } from "@uprise/text";
import { extended, backgrounds } from "@uprise/colors";
import { spacing } from "@uprise/spacing";
var TaskStyle = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: ", ";\n      width: 100%;\n      height: 100%;\n\tbackground-color: ", ";\n\n\n\t&:hover {\n\t\tbackground-color: ", ";\n\t\tcursor: pointer;\n\t}\n\n\t@media (max-width: 1024px) {\n\t\tpadding: ", ";\n\n\t}\n"])), function (props) {
  return props.last ? spacing.s5 : "".concat(spacing.s5, " ").concat(spacing.s5, " 0 ").concat(spacing.s5);
}, function (props) {
  return props.active ? extended.purple.five : backgrounds.white;
}, extended.purple.five, function (props) {
  return props.last ? spacing.s3 : "".concat(spacing.s3, " ").concat(spacing.s3, " 0 ").concat(spacing.s3);
});
var Content = Styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      border-bottom: ", ";\n      display: flex;\n      flex-direction: row;\n"])), function (props) {
  return props.last ? 0 : "1px solid ".concat(extended.purple.five);
});
var TaskLeftStyle = Styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      width: 100%;\n      height: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n"])));
var TaskRightStyle = Styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\talign-self: flex-start;\n      display: flex;\n\tflex-direction: row;\n"])));
var TaskTextStyle = Styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      width: 210px;\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var IconLeftImage = Styled.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tmargin-top: ", ";\n\tmargin-right: ", ";\n      height: 20px;\n      width: 20px;\n"])), spacing.s31, spacing.s5);
var IconRightImage = Styled.img(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tmargin-top: ", ";\n      height: 20px;\n      width: 20px;\n"])), spacing.s3);
export var TaskButton = function TaskButton(_ref) {
  var index = _ref.index,
      active = _ref.active,
      last = _ref.last,
      type = _ref.type,
      activity = _ref.activity,
      task = _ref.task,
      skillId = _ref.skillId,
      iconLeft = _ref.iconLeft,
      completedIcon = _ref.completedIcon,
      handleClick = _ref.handleClick;

  var _activity$task$taskId;

  var title, subTitle;

  switch (type) {
    case "lessons":
      title = task.title;
      break;

    case "homework":
      title = "Exercise:  ".concat(index + 1);
      subTitle = task.altTitle || task.title;
      break;

    case "faqs":
      title = "FAQs";
      break;

    case "practice":
      title = "Practice";
      break;

    case "summary":
      title = "Summary";
      break;

    case "science":
      title = "Science";
      break;

    case "examples":
      title = "Example:  ".concat(index + 1);
      break;

    case "bonus":
      title = task.title;
      break;
  }

  return /*#__PURE__*/React.createElement(TaskStyle, {
    key: index,
    last: last,
    active: active,
    onClick: function onClick() {
      return handleClick();
    }
  }, /*#__PURE__*/React.createElement(Content, {
    last: last
  }, /*#__PURE__*/React.createElement(TaskLeftStyle, null, /*#__PURE__*/React.createElement(IconLeftImage, {
    src: iconLeft
  }), /*#__PURE__*/React.createElement(TaskTextStyle, null, /*#__PURE__*/React.createElement(H6, {
    className: "m-b-0 m-t-0"
  }, title), subTitle && /*#__PURE__*/React.createElement(H6, {
    className: "m-b-0 m-t-0",
    weight: "normal"
  }, subTitle), /*#__PURE__*/React.createElement(Tiny, {
    className: "".concat(last ? "m-b-0 m-t-0 " : "m-b-3 m-t-0 ")
  }, type === "bonus" || type === "homework" || type === "lessons" ? moment(task.time, "HH:mm:ss").format("mm:ss") + " min" : ""))), /*#__PURE__*/React.createElement(TaskRightStyle, null, task.taskId && ((_activity$task$taskId = activity[task.taskId]) === null || _activity$task$taskId === void 0 ? void 0 : _activity$task$taskId.completed) && /*#__PURE__*/React.createElement(IconRightImage, {
    "data-testid": "completed-".concat(task.taskId, "-icon"),
    src: completedIcon
  }))));
};
TaskButton.propTypes = {
  activity: object.isRequired,
  last: bool.isRequired,
  active: bool,
  skillId: string.isRequired,
  iconLeft: string.isRequired,
  completedIcon: string
};
TaskButton.defaultProps = {
  index: 0
};